import { Box, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { MyAccount } from "areas/account/components"
import PortalMenu from "areas/checkout/order-complete/portal/menu"
import { IS_JEWLR, IS_PORTAL } from "helpers/application"
import withAuth from "hoc/account/with-auth"

const OrderNumberBox = styled(Box)`
  background: rgba(0, 136, 0, 0.05);
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  padding: 12px 0;
  text-align: center;
  width: 100%;
  ${(props) => props.theme.mediaQueries.tablet`
    width: 200px;
  `}
`

const OrderNumber = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  ${(props) => props.theme.mediaQueries.tablet`
    font-size: 18px;
  `}
`

const Intro = ({ data, loggedIn, toAuthenticate }) => (
  <Box mt={{ _: 4, tablet: 6 }}>
    {IS_PORTAL() && <PortalMenu invoiceLink={data.invoice_link} />}
    <Flex
      flexDirection={{ _: "column", tablet: "row" }}
      justifyContent="space-between"
      mt={{ _: 4, tablet: "60px" }}
    >
      <Typography
        as="h1"
        fontSize="32px"
        fontWeight="700"
        lineHeight="36px"
        mb={{ _: 2, tablet: 0 }}
      >
        Your Order Status
      </Typography>
      {IS_JEWLR() && (
        <Box fontSize="16px" letterSpacing="-0.02em" textAlign="right">
          {loggedIn ? (
            <MyAccount as={Link} data-lc="intro" to="/account">
              Go to My Account
            </MyAccount>
          ) : (
            <MyAccount onClick={toAuthenticate}>
              Sign into your accout
            </MyAccount>
          )}
          <Typography
            display={{ _: "none", tablet: "block" }}
            fontWeight="300"
            lineHeight="22px"
          >
            to view full order details.
          </Typography>
        </Box>
      )}
    </Flex>
    <Box mt={2}>
      <OrderNumberBox>
        Order Number:
        <OrderNumber>{data.order_number}</OrderNumber>
      </OrderNumberBox>
    </Box>
  </Box>
)

Intro.propTypes = {
  data: PropTypes.object,
  loggedIn: PropTypes.bool,
  toAuthenticate: PropTypes.func,
}

export default withAuth(Intro)
